module.exports = __webpack_public_path__ + "img/软件服务智慧教育2.e3196e84.jpg";